// Keeps --isp-zoom-scale (read by .oi-isp-point in _isp.scss) in sync with the live scale of
// each ISP's .oi-panzoom-canvas, so pins can counter-scale against it and hold a constant
// on-screen size instead of growing/shrinking 1:1 with the map image as a visitor zooms.
//
// There's no public hook into oilib's own panzoom instance (isp.js keeps it in a closured
// local variable) to listen for zoom changes directly, so this watches the one place the
// resulting scale is guaranteed to show up no matter how it changed -- wheel, pinch, drag, or
// the +/-/reset buttons all end up setting the canvas's own inline `transform` style. Custom
// properties inherit, so setting it once on the canvas reaches every pin under it.
(function () {
    function currentScale(canvas) {
        var transform = getComputedStyle(canvas).transform;
        if (!transform || transform === 'none') return 1;
        // 2D transforms report as matrix(a, b, c, d, tx, ty). panzoom only ever applies
        // uniform scale + translate here (no rotate/skew), so `a` alone is the scale factor.
        var match = transform.match(/^matrix\(([^,]+),/);
        var scale = match && parseFloat(match[1]);
        return scale || 1;
    }

    document.querySelectorAll('.oi-panzoom-canvas').forEach(function (canvas) {
        var sync = function () {
            canvas.style.setProperty('--isp-zoom-scale', currentScale(canvas));
        };
        sync();
        new MutationObserver(sync).observe(canvas, { attributes: true, attributeFilter: ['style'] });
    });
})();
